const resourceEnumerators = {
  type: [
    // 'file',
    // 'image',
    'all',
    'form',
    'folder',
    'closing-form',
    'attachment-form',
  ],
  relatedTo: ['asset', 'location', 'resource'],
  status: [
    'opened',
    'closed',
    // 'pending',
    // 'draft',
    'validated',
    'rejected',
    // 'completed',
    'pending_validation',
    'pending_signature',
    // 'expired',
    // 'current',
    // 'overdue',
    // 'toExpired',
  ],
  priority: ['high', 'medium', 'low'],
  conditionType: ['secure', 'insecure'],
  sendedNotifications: ['validators'],
};

export default resourceEnumerators;
